// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"AdminAddGym_dashboardContainer__20ae7","notification":"AdminAddGym_notification__100-s"};